import visualizationService from "../../services/visualizationService";
import { initialState } from "./initialState";
import * as types from "./types";
import { errorMessage } from "../../constants/responseMessages";

export const setProductSitesUopFilters = (payload) => async (dispatch) => {
  dispatch({
    type: types.SET_PARAMETER_SITES_UNIT_OPERATIONS_FILTERS,
    payload: payload,
  });
};

// export const clearProductSitesUopFilters = (payload) => async (dispatch) => {
//   dispatch({
//     type: types.SET_PARAMETER_SITES_UNIT_OPERATIONS_FILTERS,
//     payload: {},
//   });
// };
